import { Validators } from "@angular/forms";
import moment = require("moment");
import { IFormKey } from "src/app/modules/shared/models/forms";
import { ESpecificBeneficiaryType } from "../beneficiary-form-isv/beneficiary-form-isv.constants";

export const effective_owner_positional_text = ['primo', 'secondo', 'terzo', 'quarto'];

export const options_yes_no = [
    {
        key: 'SI',
        value: 'Sì'
    },
    {
        key: 'NO',
        value: 'No'
    }
]

export const operation_data_form_keys: IFormKey[] = [
    {
        id: 'agencyCode-field',
        label: 'Numero agenzia',
        controlName: 'agencyCode',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'policyNumber-field',
        label: 'Numero proposta / polizza',
        controlName: 'policyNumber',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'productCode-field',
        label: 'Codice prodotto',
        controlName: 'productCode',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'productCategory-field',
        label: 'Categoria prodotto',
        controlName: 'productCategory',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'reportScope-field',
        label: 'Scopo del rapporto',
        controlName: 'reportScope',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'additionalPaymentType-field',
        label: 'Versamento',
        controlName: 'additionalPaymentType',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'redeemType-field',
        label: 'Riscatto',
        controlName: 'redeemType',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'liquidationType-field',
        label: 'Liquidazione',
        controlName: 'liquidationType',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'withdrawalType-field',
        label: 'Recesso',
        controlName: 'withdrawalType',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'operationAmount-field',
        label: "Importo dell'operazione",
        controlName: 'operationAmount',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'paymentType-field',
        label: 'Mezzo di pagamento',
        controlName: 'paymentType',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fundOrigin-field',
        label: 'Origine dei fondi',
        controlName: 'fundOrigin',
        css: 'col-3',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fundOriginCountry-field',
        label: 'Paese di provenienza o destinazione dei fondi',
        controlName: 'fundOriginCountry',
        css: 'col-6',
        type: 'SELECT',
        options: []
    },
    {
        id: 'fundOriginNote-field',
        label: 'Note origine fondi',
        controlName: 'fundOriginNote',
        css: 'col-6',
        type: 'INPUT'
    },
    {
        id: 'designedBeneficiary-field',
        label: 'Designazione beneficiario',
        controlName: 'designedBeneficiary',
        css: 'col-3',
        type: 'SELECT',
        options: options_yes_no
    },
    {
        id: 'contractorNotInsured-field',
        label: 'Contraente diverso da assicurato',
        controlName: 'contractorNotInsured',
        css: 'col-3',
        type: 'SELECT',
        options: options_yes_no
    }
];

export const operation_purpose_form_key: IFormKey = {
    id: 'operationPurpose-field',
    label: "Scopo dell'operazione",
    controlName: 'operationPurpose',
    css: 'col-6',
    type: 'SELECT',
    options: []
}

export const operator_data_form_template = {
    collectedDocs: { value: null, disabled: true },
    subscriptionPlace: { value: null, disabled: false },
    operatorSubscription: { value: null, disabled: false },
    subscriptionDate: { value: null, disabled: true }
}

export const operator_data_form_validators = {
    collectedDocs: null,
    subscriptionPlace: [Validators.required],
    operatorSubscription: [Validators.required],
    subscriptionDate: [Validators.required]
}

export const operator_data_form_keys: IFormKey[] = [
    {
        id: 'collectedDocs-field',
        label: 'Documentazione raccolta che attesta i poteri del soggetto che agisce per nome e per conto del contraente',
        controlName: 'collectedDocs',
        css: 'col-9',
        type: 'SELECT',
        options: []
    },
    {
        id: 'subscriptionDate-field',
        controlName: 'subscriptionDate',
        label: 'Data di sottoscrizione',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'subscriptionPlace-field',
        label: 'Luogo di sottoscrizione',
        controlName: 'subscriptionPlace',
        css: 'col-6',
        type: 'INPUT'
    },
    {
        id: 'operatorSubscription-field',
        label: 'Sottoscrizione del rilevatore',
        controlName: 'operatorSubscription',
        css: 'col-6',
        type: 'INPUT'
    }
]

export const insured_form_template = {
    name: null,
    surname: null,
    birthDate: null,
    birthPlace: null,
    fiscalCode: null,
    isPEP: null
}

export const insured_form_validators = {
    name: [Validators.required],
    surname: [Validators.required],
    birthDate: [Validators.required],
    birthPlace: [Validators.required],
    fiscalCode: [Validators.required],
    isPEP: [Validators.required]
}

export const insured_form_keys: IFormKey[] = [
    {
        id: 'insured-name-field',
        label: 'Nome',
        controlName: 'name',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'insured-surname-field',
        label: 'Cognome',
        controlName: 'surname',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'insured-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment()
    },
    {
        id: 'insured-birthPlace-field',
        label: 'Luogo di nascita',
        controlName: 'birthPlace',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'insured-fiscalCode-field',
        label: 'Codice fiscale',
        controlName: 'fiscalCode',
        css: 'col-3',
        type: 'INPUT'
    },
    {
        id: 'insured-isPEP-field',
        label: 'Presenza nelle liste esterne',
        controlName: 'isPEP',
        css: 'col-3',
        type: 'SELECT',
        options: options_yes_no
    }
]

export const beneficiary_form_template = {
    designatedBeneficiary: null,
    beneficiaryType: null,
    description: null,
    name: null,
    companyName: null,
    surname: null,
    birthDate: null,
    companyDate: null,
    birthPlace: null,
    companyPlace: null,
    fiscalCode: null,
    vatCode: null,
    isPEP: null,
    beneficiaryContractorRelationship: null,
    beneficiaryInsuredRelationship: null,
}

export const beneficiary_form_validators = {
    designatedBeneficiary: [Validators.required],
    beneficiaryType: [Validators.required],
    description: [Validators.required],
    name: [Validators.required],
    companyName: [Validators.required],
    surname: [Validators.required],
    birthDate: [Validators.required],
    companyDate: [Validators.required],
    birthPlace: [Validators.required],
    companyPlace: [Validators.required],
    fiscalCode: [Validators.required],
    vatCode: [Validators.required],
    isPEP: [Validators.required],
    beneficiaryContractorRelationship: [Validators.required],
    beneficiaryInsuredRelationship: [Validators.required],
}

export const beneficiary_form_keys: IFormKey[] = [
    {
        id: 'designated-beneficiary-field',
        label: 'Beneficiario designato',
        controlName: 'designatedBeneficiary',
        css: 'col-4',
        type: 'RADIO',
        options: options_yes_no,
        hidden: false
    },
    {
        id: 'beneficiary-new-line-field',
        label: null,
        controlName: 'beneficiaryNewLine',
        type: 'NEW_LINE',
        css: 'col-12',
        hidden: false
    },
    {
        id: 'beneficiary-description-field',
        label: 'Descrizione',
        controlName: 'description',
        css: 'col-8',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiaryType-isv-field',
        label: 'Tipologia Persona',
        controlName: 'beneficiaryType',
        css: 'col-3',
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA
            }
        ],
        hidden: true
    },
    {
        id: 'beneficiary-name-field',
        label: 'Nome',
        controlName: 'name',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-surname-field',
        label: 'Cognome',
        controlName: 'surname',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-birthDate-field',
        controlName: 'birthDate',
        label: 'Data di nascita',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment(),
        hidden: true
    },
    {
        id: 'beneficiary-birthPlace-field',
        label: 'Luogo di nascita',
        controlName: 'birthPlace',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-fiscalCode-field',
        label: 'Codice fiscale',
        controlName: 'fiscalCode',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-isPEP-field',
        label: 'Presenza nelle liste esterne',
        controlName: 'isPEP',
        css: 'col-3',
        type: 'SELECT',
        options: [],
        hidden: true
    },
    {
        id: 'beneficiary-pg-description-field',
        label: 'Denominazione sociale',
        controlName: 'companyName',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-companyDate-field',
        controlName: 'companyDate',
        label: 'Data di costituzione',
        css: 'col-3',
        type: 'DATEPICKER',
        maxDate: moment(),
        hidden: true
    },
    {
        id: 'beneficiary-companyPlace-field',
        label: 'Luogo di costituzione',
        controlName: 'companyPlace',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-vatCode-field',
        label: 'Partita IVA',
        controlName: 'vatCode',
        css: 'col-3',
        type: 'INPUT',
        hidden: true
    },
    {
        id: 'beneficiary-beneficiaryContractorRelationship-field',
        label: 'Relazione tra contraente e beneficiario',
        controlName: 'beneficiaryContractorRelationship',
        css: 'col-3',
        type: 'SELECT',
        options: [],
        hidden: true
    },
    {
        id: 'beneficiary-beneficiaryInsuredRelationship-field',
        label: 'Relazione tra assicurato e beneficiario',
        controlName: 'beneficiaryInsuredRelationship',
        css: 'col-3',
        type: 'SELECT',
        options: [],
        hidden: true
    }
]

export const beneficiary_not_designated_fields = [
    'description'
];

export const beneficiary_PF_fields = [
    'name',
    'surname',
    'birthDate',
    'birthPlace',
    'fiscalCode',
    'isPEP',
    'beneficiaryContractorRelationship',
    'beneficiaryInsuredRelationship'
];

export const beneficiary_PG_fields = [
    'companyName',
    'companyDate',
    'companyPlace',
    'vatCode',
    'beneficiaryContractorRelationship',
    'beneficiaryInsuredRelationship'
];